import { useInheritedColor } from '@nivo/colors';

interface styleConfigProps {
  LabelTextColorControl: {
    from: string,
    modifiers: [['brighter' | 'darker' | 'opacity', number]]
  };
  LabelsFontSizeControl: { value: number };
  LabelsFontFamilyControl: { value: string };
  LabelTranslateX: number;
  LabelTranslateY: number;
  LabelRotationControl: number;
}

interface globalConfigProps {
  useGlobalFont: boolean;
  fontLabel: string;
}

interface Dt {
  key: string;
  x: number;
  y: number;
  width: number;
  height: number;
  data: Record<string, any>;
}

interface CustomLabelProps {
  data: Dt[];
  styleConfig: styleConfigProps;
  globalConfig: globalConfigProps;
  content: (dt: Dt['data'], x: number) => React.ReactNode;
}

const CustomLabel = ({
  data, styleConfig, globalConfig, content,
}: CustomLabelProps) => {
  const {
    LabelTextColorControl,
    LabelsFontSizeControl,
    LabelsFontFamilyControl,
    LabelTranslateX,
    LabelTranslateY,
    LabelRotationControl,
  } = styleConfig;
  const getColor = useInheritedColor(LabelTextColorControl);

  return data.map((dt) => (
    <g
      key={dt.key}
      transform={`translate(${dt.x}, ${dt.y})`}
    >
      <text
        x={dt.width / 2}
        y={dt.height / 2}
        textAnchor="middle"
        dominantBaseline="central"
        fillOpacity={1}
        style={{
          fontSize: `${LabelsFontSizeControl ? LabelsFontSizeControl.value : 13}px`,
          fontFamily: `'${globalConfig?.useGlobalFont ? globalConfig.fontLabel : LabelsFontFamilyControl?.value}', Arial`,
          transform: `translate(${LabelTranslateX || 0}px, ${LabelTranslateY || 0}px) rotate(${LabelRotationControl || 0}deg)`,
          transformOrigin: 'center center',
          transformBox: 'fill-box',
          pointerEvents: 'none',
          fill: getColor(dt),
        }}
      >
        {content(dt.data, dt.width / 2)}
      </text>
    </g>
  ));
};

export default CustomLabel;
